import toast from "react-hot-toast"

export const handleError = (response) => {
    if (response) {
        if (typeof response === "string") {
            console.warn(response)
            toast.error(response)
        } else if (response?.ExceptionMessage || response?.Message) {
            console.warn(response)
            toast.error(response?.ExceptionMessage || response?.Message)
        }
    }
}

export const isTypeOf = (value, type) => {
    switch (type) {
        case "string":
            return typeof value === "string"
        case "array":
            return typeof value === "object" && value && value?.length >= 0
        case "object":
            return (typeof value === "object" && value && Object.keys(value)?.length >= 0)
        case "boolean":
            return typeof value === "boolean"
        case "number":
            return typeof value === "number"
        case "null":
            return value === null
        case "undefined":
            return value === undefined
        default:
            return false
    }
}

export const convertRespArrToLabelObject = (arr) => {
    let convertedObject = {}

    if (isTypeOf(arr, "array")) {
        arr?.forEach((labels) => {
            Object.assign(convertedObject, { [`${labels.Placeholder}`]: labels.Text })
        })
    }

    return convertedObject
}

export const getDynamicLabel = (labelFromApi, defaultLabel) => {
    return labelFromApi?.trim() ? (
        labelFromApi?.trim()
    ) : defaultLabel?.trim() ? (
        defaultLabel?.trim()
    ) : ("")
}
